<template>
	<form class="form-horizontal">
		<fieldset>
			<!-- Multiple Radios (inline) -->
			<div class="form-group">
				<label class="col-md-4 control-label" for="radios" style="text-align: right">Hauptkontakt</label>
				<div class="col-md-4">
					<label class="radio-inline" for="radios-0">
						<input name="radios" id="radios-0" value="true" :checked="model.model.is_main" type="radio" @click="model.model.is_main = true">
						Ja
					</label>
					<label class="radio-inline" for="radios-1">
						<input name="radios" id="radios-1" value="false" :checked="!model.model.is_main" type="radio" @click="model.model.is_main = false">
						Nein
					</label>
				</div>
			</div>

			<!-- Select Basic -->
			<div class="form-group">
				<label class="col-md-4 control-label" for="selectbasic" style="text-align: right">Art</label>
				<div class="col-md-4">
					<select id="contact_list" v-model="model.model.mode" class="form-control">
						<option v-for="contacttype in $store.getters.models('contact_types')" :value="contacttype.id">{{ contacttype.name }}</option>
					</select>
				</div>
			</div>

			<!-- Text input-->
			<div class="form-group">
				<label class="col-md-4 control-label" for="textinput" style="text-align: right">Nummer / E-Mail</label>
				<div class="col-md-4">
					<input name="zip" class="form-control" required="required" v-model="model.model.value">

				</div>
			</div>

			<!-- Text input-->
			<div class="form-group">
				<label class="col-md-4 control-label" for="textinput" style="text-align: right">Beschreibung / Anmerkung</label>
				<div class="col-md-4">
					<input name="zip" class="form-control" required="required" v-model="model.model.description">
				</div>
			</div>

		</fieldset>
	</form>
</template>

<script>
import Contact from "models/contacts.js"
import { ModelListSelect } from 'vue-search-select'

export default {
	data () {
		return {
			model: Contact
		}
	},

	mounted () {
		this.$store.dispatch('loadModel', 'contact_types')
	},

	computed: {
		selectedZip: {
			get () {
				return {
					"zip": this.model.model.zip,
					"city": this.model.model.city
				}
			},

			set (aModel) {
				this.model.model.zip = aModel.zip
				this.model.model.city = aModel.city
			}
		}
	},

	methods: {
		computeZip (aModel) {
			return aModel.zip + " " + aModel.city
		}
	},

	components: {
		ModelListSelect
	}
}
</script>


// WEBPACK FOOTER //
// contact-content.vue?6e55eb8a